"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const shallow_1 = require("zustand/shallow");
const useAdjustWeightModal_1 = require("hooks/useAdjustWeightModal/useAdjustWeightModal");
const HelperUtils_1 = require("utils/HelperUtils");
const BannerBox_1 = __importDefault(require("components/shared/BannerBox"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const Banner = () => {
    const { totalWeights, totalObjectives, isPercentage, maxSumOfObjectivesOnBasedOnCategory, maxSumOfObjectivesBasedOnCategory } = (0, useAdjustWeightModal_1.useAdjustWeightModalStore)((state) => ({
        totalWeights: state.totalWeights,
        totalObjectives: state.totalObjectives,
        isPercentage: state.isPercentage,
        maxSumOfObjectivesOnBasedOnCategory: state.maxSumOfObjectivesOnBasedOnCategory,
        maxSumOfObjectivesBasedOnCategory: state.maxSumOfObjectivesBasedOnCategory
    }), shallow_1.shallow);
    const isShowWarningWeight = maxSumOfObjectivesOnBasedOnCategory &&
        totalWeights > maxSumOfObjectivesBasedOnCategory;
    const getTotalObjectivesLocale = (totalObjectives) => {
        const stringArray = (0, HelperUtils_1.getObjectiveLocale)(`Accumulated with [total_objectives] other top parent objective(s) ${isShowWarningWeight && maxSumOfObjectivesOnBasedOnCategory
            ? `and total weight must be ${maxSumOfObjectivesBasedOnCategory}${isPercentage ? '%' : ''}`
            : ''}`).replace(/\[total_objectives]/g, (0, HelperUtils_1.getNumberLocale)(totalObjectives));
        return stringArray;
    };
    return (react_1.default.createElement(BannerBox_1.default, { type: isShowWarningWeight ? 'error' : 'info', withIcon: false, paddingClass: "px-[16px] py-[8px]", customClass: "h-[56px]" },
        react_1.default.createElement("div", { className: "flex items-center justify-between w-full" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("p", { className: "typography-h400 text-n-900 mb-[4px]" }, (0, HelperUtils_1.getObjectiveLocale)('Total Weight')),
                react_1.default.createElement("p", { className: "typography-h100 text-n-800", "data-cy": "total-objectives" }, getTotalObjectivesLocale(totalObjectives))),
            react_1.default.createElement("div", { className: "flex items-center" },
                isShowWarningWeight && maxSumOfObjectivesOnBasedOnCategory && (react_1.default.createElement(SVGIcon_1.default, { size: 16, fillColor: "var(--y-600)", iconName: "icon-warning", customClass: "mr-[8px]" })),
                react_1.default.createElement("span", { className: "typography-h400 text-n-900", "data-cy": "total-weight" },
                    totalWeights,
                    "%")))));
};
exports.default = Banner;
